import React, { Component } from 'react';
import { connect } from "react-redux";
import Swal from 'sweetalert2';


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class OperatorNotFoundSettings extends Component {

    constructor(props) {
        super(props);

console.log(this.props.operatorNotFoundMessage);
    }

    componentWillUnmount() {
        Swal.close();
    }





    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <div className="hv-setting-item-container">
                    <div className="language-settings-input-container">


                        <div className="language-settings-input">
                            <label>Offline info</label>
                            <div>
                                <textarea onChange={evt => this.props.setOperatorNotFoundMessage(evt)}>{this.props.operatorNotFoundMessage}</textarea>

                            </div>
                        </div>

                    </div>

                </div>
            </React.Fragment>
        );
    }
}

export default OperatorNotFoundSettings;
